export const familyNames = [
  "Nagy",
  "Kovács",
  "Tóth",
  "Szabó",
  "Horváth",
  "Varga",
  "Kiss",
  "Molnár",
  "Németh",
  "Balogh",
  "Farkas",
  "Lakatos",
  "Papp",
  "Takács",
  "Juhász",
  "Oláh",
  "Mészáros",
  "Simon",
  "Rácz",
  "Fekete",
  "Szilágyi",
  "Török",
  "Fehér",
  "Balázs",
  "Gál",
  "Kis",
  "Szűcs",
  "Orsós",
  "Kocsis",
  "Fodor",
  "Pintér",
  "Szalai",
  "Sipos",
  "Magyar",
  "Lukács",
  "Gulyás",
  "Balog",
  "Biró",
  "Király",
  "László",
  "Bogdán",
  "Jakab",
  "Katona",
  "Váradi",
  "Sándor",
  "Boros",
  "Fazekas",
  "Kelemen",
  "Orosz",
  "Antal",
  "Somogyi",
  "Fülöp",
  "Budai",
  "Veres",
  "Vincze",
  "Deák",
  "Hegedűs",
  "Pap",
  "Bálint",
  "Illés",
  "Pál",
  "Vass",
  "Szőke",
  "Fábián",
  "Jónás",
  "Lengyel",
  "Bodnár",
  "Bognár",
  "Vörös",
  "Szücs",
  "Hajdu",
  "Halász",
  "Máté",
  "Székely",
  "Kozma",
  "Gáspár",
  "Pásztor",
  "Bakos",
  "Dudás",
  "Virág",
  "Major",
  "Orbán",
  "Hegedüs",
  "Barna",
  "Novák",
  "Tamás",
  "Soós",
  "Nemes",
  "Pataki",
  "Balla",
  "Csonka",
  "Péter",
  "Faragó",
  "Barta",
  "Borbély",
  "Mezei",
  "Kerekes",
  "Sárközi",
  "Berki",
  "Márton"
];

export const maleSurnames = [
  "Dominik",
  "Olivér",
  "Levente",
  "Máté",
  "Marcell",
  "Noel",
  "Bence",
  "Zalán",
  "Milán",
  "Ádám",
  "Botond",
  "Dániel",
  "Zsombor",
  "Benett",
  "Áron",
  "Dávid",
  "Balázs",
  "Benedek",
  "Nimród",
  "Márk",
  "Zente",
  "Nolen",
  "Bálint",
  "Péter",
  "Kristóf",
  "László",
  "Zétény",
  "Tamás",
  "Barnabás",
  "Kornél",
  "Alex",
  "Hunor",
  "András",
  "Martin",
  "Gergő",
  "Zoltán",
  "Márton",
  "Attila",
  "Ábel",
  "Ákos",
  "Patrik",
  "Bendegúz",
  "Vince",
  "Gábor",
  "Soma",
  "István",
  "Erik",
  "Sándor",
  "Krisztián",
  "Zsolt",
  "József",
  "Benjámin",
  "János",
  "Roland",
  "Mátyás",
  "Csongor",
  "Ármin",
  "Nándor",
  "Kevin",
  "Ferenc",
  "Vencel",
  "Csaba",
  "Róbert",
  "Norbert",
  "Richárd",
  "Benjamin",
  "Mihály",
  "Kende",
  "Boldizsár",
  "Szabolcs",
  "Simon",
  "Zénó",
  "Viktor",
  "Gergely",
  "Tibor",
  "Vilmos",
  "Dorián",
  "Miron",
  "Laurent",
  "Bende",
  "Nátán",
  "Teodor",
  "Bertalan",
  "Denisz",
  "Mirkó",
  "Adrián",
  "Miklós",
  "Félix",
  "Donát",
  "Krisztofer",
  "Sámuel",
  "Imre",
  "Brájen",
  "Noé",
  "Gellért",
  "Eliot",
  "Dénes",
  "Merse",
  "Alexander",
  "Iván"
];

export const femaleSurnames = [
  "Hanna",
  "Anna",
  "Luca",
  "Zoé",
  "Léna",
  "Emma",
  "Olívia",
  "Boglárka",
  "Lili",
  "Kamilla",
  "Laura",
  "Szofia",
  "Lilien",
  "Mira",
  "Alíz",
  "Sára",
  "Zsófia",
  "Flóra",
  "Lara",
  "Adél",
  "Izabella",
  "Jázmin",
  "Nóra",
  "Janka",
  "Liza",
  "Bella",
  "Linett",
  "Lilla",
  "Fanni",
  "Maja",
  "Gréta",
  "Zselyke",
  "Panna",
  "Dorka",
  "Emília",
  "Blanka",
  "Rebeka",
  "Liliána",
  "Abigél",
  "Csenge",
  "Elena",
  "Milla",
  "Nara",
  "Natasa",
  "Bianka",
  "Elizabet",
  "Eszter",
  "Lotti",
  "Dóra",
  "Róza",
  "Szofi",
  "Szófia",
  "Viktória",
  "Petra",
  "Noémi",
  "Odett",
  "Júlia",
  "Eliza",
  "Dorina",
  "Réka",
  "Lujza",
  "Amira",
  "Johanna",
  "Nazira",
  "Boróka",
  "Hanga",
  "Zora",
  "Panka",
  "Emili",
  "Mia",
  "Szonja",
  "Zorka",
  "Vivien",
  "Natália",
  "Zejnep",
  "Lia",
  "Tamara",
  "Elina",
  "Norina",
  "Nina",
  "Letícia",
  "Bíborka",
  "Diána",
  "Fruzsina",
  "Alina",
  "Hédi",
  "Borbála",
  "Regina",
  "Lana",
  "Mirella",
  "Olivia",
  "Dorottya",
  "Mirabella",
  "Alexandra",
  "Kincső",
  "Lora",
  "Zita",
  "Kinga",
  "Rozina",
  "Luna"
];
